import React, { ReactNode, useEffect } from 'react';
import { createRoot } from 'react-dom/client';
// @ts-ignore
import { Root } from './containers/Root/Root.js';
import configureStore from './config/store/configureStore';
import ResetPwd from './components/UserManagement/ResetPassword';
import './config/normalize.css';
import "leaflet/dist/leaflet.css";
import 'react-redux-toastr/src/styles/index.scss';
import { ThemeProvider } from '@mui/material/styles';
import { dispatch_theme } from './config/colors';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import enLocale from 'date-fns/locale/en-US';
import deLocale from 'date-fns/locale/de';
import CssBaseline from '@mui/material/CssBaseline';
import favicon from '@/components/Common/Icons/favicon.svg';
import { default as ErrorBoundary } from '@/components/Common/ErrorBoundary';
import hotjar from '../util/hotjar';
import * as Sentry from '@sentry/react';
import { i18next } from './config/i18n';

// TODO fix
// @ts-ignore
const { store, persistor, history }: any = configureStore();
(window as any).store = store;
export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

export const localeMap: { [key: string]: any } = {
  'en': enLocale,
  'de': deLocale,
};

export const {
  Cypress,
  instance,
  instance: {
    customerurl,
    frontendurl,
    customername,
    companyname,
    firstname,
    lastname,
    activationcode,
    email,
    assets_source,
    showPage,
    usertype,
    frontend_flags,
  },
}: any = window;

// eslint-disable-next-line no-unused-vars
const [a, b, c, bucket, version] = assets_source.split('/');
export { store };
if (window.Cypress) {
  window.customerurl = 'https://dispatch-dev.dev.smartlane.io/';
  window.store = store;
}
if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: 'https://247386c5cd494478a1ef10cfae3a2085@o397629.ingest.sentry.io/5252259',
    release: `${bucket || 'local'} ${version || 'v0'}`,
    environment: process.env.NODE_ENV,
    beforeSend(event) {
      const {
        request: { url },
      }: any = event;
      const localdev = new RegExp(/http:\/\/localhost.*/);
      const dockerenv = new RegExp(/http:\/\/web.*/);
      if (localdev.test(url) || dockerenv.test(url)) return null;
      return event;
    },
  });

  Sentry.withScope(function (scope) {
    store.getState().core.ui.map((flag: string) => {
      scope.setTag(flag.toString(), 'active');
    });
    scope.setTag('commit', process.env.COMMIT);
  });
}

type UtilProps = {
  children: ReactNode;
};

function UtilWrapper({ children }: UtilProps) {

  useEffect(() => {
    if (
      typeof frontend_flags !== 'undefined' &&
      frontend_flags.includes('hotjar')
    ) {
      hotjar(
        window,
        document,
        'https://static.hotjar.com/c/hotjar-',
        '.js?sv=',
      );
    }
  }, []);

  return (
    <ThemeProvider theme={dispatch_theme}>
      <>
        <CssBaseline />
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={localeMap[i18next.language]}>
          <>{children}</>
        </LocalizationProvider>
      </>
    </ThemeProvider>
  );
}

import './config/openFeature';
import { OpenFeatureProvider } from '@openfeature/react-sdk';

const Index = () => {
  useEffect(() => {
    if (document.getElementById('init-loading')) {
      document.getElementById('init-loading').outerHTML = '';
    }
  }, []);

  return (
    <UtilWrapper>
      <OpenFeatureProvider>
        {/*// @ts-ignore */}
        <Root store={store} history={history} persistor={persistor} />
      </OpenFeatureProvider>
    </UtilWrapper>
  );
};

document.body.innerHTML += '<div id="app" class="base"></div>';
document.body.innerHTML += '<div id="init-loading"></div>';
// Quoted href: svg-url-loader leaves spaces in the data URI (it only collapses runs),
// so an unquoted attribute would truncate at the first one. It converts every `"` in the
// SVG to `'`, so double quotes here can never be closed early by the payload.
document.head.innerHTML += `<link rel="shortcut icon" type="image/svg+xml" href="${favicon}">`;

const container = document.getElementById('app');
const root = createRoot(container);

switch (showPage) {
  case 'resetpwd':
    root.render(
      <UtilWrapper>
        {/*
  // @ts-ignore */}
        <ErrorBoundary>
          <ResetPwd />
        </ErrorBoundary>
      </UtilWrapper>
    );
    break;

  default: {
    const waitForFlagsAndRender = () => {
      const flags = window?.instance?.frontend_flags;
      if (Array.isArray(flags)) {
        if (!flags.includes('planning_table')) {
          flags.push('planning_table');
        }
        const { setUI } = require('./actions/common/commonPure');
        store.dispatch(setUI(flags));
        root.render(<Index />);
      } else {
        setTimeout(waitForFlagsAndRender, 50);
      }
    };
    waitForFlagsAndRender();
  }
}
